export const account_type = {
    ADMIN: "admin",
    EMPLOYEE: "employee",
    USER: "user",
  };
  
 export const permission_type = {
    CREATE_USER: "create_user",
    CREATE_EMPLOYEE: "create_employee",
    VIEW_USER_LIST: "view_user_List",
    VIEW_EMPLOYEE_LIST: "view_employee_List",
    VIEW_USER:"view_user",
    VIEW_EMPLOYEE:"view-employee",
    EDIT_USER: "edit_user",
    EDIT_EMPLOYEE: "edit_employee",
  
  };
  

  